module.exports = "/_next/static/images/GeneralM-871612e6072e88741160548107307db1.svg";